import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DownloadAppComponent } from './Features/components/download-app/download-app.component';
import { Platform } from '@angular/cdk/platform';
import { DownloadAppBannerComponent } from './Features/components/download-app-banner/download-app-banner.component';
import { ReciterService } from './Features/service/reciter.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    DownloadAppComponent,
    DownloadAppBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  isMobileEnv!: boolean;
  isMobBannerClose!: boolean;
  currentPage!: string;

  constructor(
    public platform: Platform,
    private _reciterService: ReciterService
  ) {
    this._reciterService.currentPage.subscribe((res: any) => {
      this.currentPage = res;
    });
  }

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      if (this.platform.ANDROID || this.platform.IOS) {
        this.isMobileEnv = true;
      } else {
        this.isMobileEnv = false;
      }
        this.addScript();
    }
  }

  closeMobBanner(value: boolean) {
    this.isMobBannerClose = value;
  }

  addScript() {
    let script = document.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {
      "@context" : "https://schema.org",
      "@type" : "WebSite",
      "name" : "Maqare | مقارئ",
      "alternateName" : "Maqare | مقارئ",
      "url" : ${environment.webSite},
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": ${environment.webSite}
        },
        "query-input": "required name=Maqare | مقارئ"
      }
    }
    `;
    document.head.append(script);
  }
}
